import { Stack, Typography } from '@mui/material';
import './clearscoremodifier-display.scss';
export interface IFusionScoreModifierDisplayProps {
  label: string;
  children: number | string;
  asPercent?: boolean;
}

export const FusionScoreModifierDisplay = ({
  children,
  label,
  asPercent,
}: IFusionScoreModifierDisplayProps) => {
  return (
    <Stack paddingLeft={2} className="fusion-score-modifier-display-container">
      <Typography className="typography-label">{label}:</Typography>
      <Typography className="typography-value">
        {typeof children === 'number'
          ? asPercent
            ? `${(children * 100)
                .toFixed(2)
                .replace(/0+$/, '')
                .replace(/\.$/, '')}%`
            : children.toFixed(2)
          : children}
      </Typography>
    </Stack>
  );
};
